<template>
	<div class="session-control-skype">
		<ui-clipboard-input
			v-model="recorderUri"
			hint="Link copied to clipboard"
			label="Recorder URI"
		/>
		<div class="ui-caption">
			<p>You can record (and optionally stream) a Skype for Business (SfB) meeting by adding the above Recorder URI to the meeting as a participant.</p>
			<p>The recording (and live streaming if enabled) will start as soon as the participant has been added to the meeting. You can also do a personal recording or live streaming by calling from SfB directly to the above address (without adding it to a meeting).</p>
			<p>We recommend that you add the above address as a Contact in SfB for easy of use.</p>
			<p>Please note that your SfB account needs to be enabled with External Communication in general, or specifically for the domain of the above address.</p>
		</div>
	</div>
</template>

<script>
import UiClipboardInput from "lib/components/ui/ClipboardInput";

export default {
	name: "SessionControlSkype",
	components: {
		UiClipboardInput
	},
	props: {
		recorder: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			recorderUri: this.recorder.uri
		};
	}
};
</script>
